import { Colors } from './types';

const colors: Colors = {
  alert: {
    default: '#EE9022',
    hover: '#FDEEDC'
  },
  buy: {
    default: '#4E8130',
    hover: '#426E29'
  },
  carphone: '#29A9DB',
  dirtyYellow: '#E4C55F',
  focusedAccent: '#E4C55F',
  shades: [
    '#000000', // 0
    '#222222', // 1
    '#333333', // 2
    '#666666', // 3
    '#999999', // 4
    '#CCCCCC', // 5
    '#F2F2F2', // 6
    '#FFFFFF' // 7
  ],
  header: {
    background: 'linear-gradient(to bottom, #1e249e, #011e62)',
    nav: {
      arrow: '#ccc',
      searchBar: {
        border: '#ccc',
        text: '#222'
      },
      link: {
        text: '#222'
      },
      mobile: {
        titleMain: '#4855A0',
        background: '#f5f7fd',
        typeLink: '#222'
      },
      desktop: {
        titleMain: '#222',
        hover: {
          text: '#4855A0',
          background: '#f5f7fd'
        }
      },
      mark: {
        background: '#C90404',
        color: '#fff'
      }
    },
    suggestions: {
      stock: {
        default: '#426e29',
        unavailable: '#e4016c'
      }
    }
  },
  link: {
    default: '#4855A0',
    hover: '#161B7A'
  },
  message: {
    default: '#4855A0',
    hover: '#F5F7FD'
  },
  pageAnchor: {
    title: '#666',
    border: '#ccc'
  },
  positive: {
    default: '#4A8130',
    hover: '#F0F6EB',
    accent: '#71BD6A'
  },
  error: {
    default: '#C90404',
    hover: '#FFF2F2',
    accent: '#C90404'
  },
  price: {
    default: '#C90404',
    hover: '#FFF2F2'
  },
  primary: {
    default: '#161B7A',
    hover: '#161B7A'
  }
};

export default colors;
